var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pageCount > 1)?_c('div',[_c('paginate',{ref:"paginate",attrs:{"click-handler":_vm.setActivePage,"page-count":_vm.pageCount,"prev-text":"«","next-text":"»","container-class":"pagination"}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04f54415","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Search/SearchPagination.vue
// module id = 709
// module chunks = 1